module.exports = __webpack_public_path__ + "static/media/AGC01.bfa835bb.png";